import { BaseAction } from "../../../core/actions/BaseAction";
import { deleteAncillaryFromOffer } from "../../../app/api/deleteAncillaryFromOffer";
import { getBooking } from "../../../app/api/getBooking";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { hideLoader, showLoader } from "../../../Lib/Utils/validationUtil";
import { AncillaryStatusEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";

type IResult = { status: "success" | "fail"; message?: string; cleaned: boolean };

export class CleanupOrphanAddonsAction extends BaseAction<IResult, void> {
  protected override deduplicate = true;

  override async run(): Promise<IResult> {
    const bookingResponse = getRecoilStateValue<IBookingResponse>("bookingResponseAtom");
    const bookingId = bookingResponse?.booking?.id || "";
    if (!bookingId) return { status: "fail", message: "Missing bookingId", cleaned: false };

    const targets: Array<{ offerId: string; ancillaryId: string }> = [];
    for (const offer of bookingResponse?.booking?.bookedOffers || []) {
      for (const anc of (offer as any).ancillaries || []) {
        if ((anc as any)?.status === AncillaryStatusEnum.PREBOOKED && (anc as any)?.id) {
          targets.push({ offerId: (offer as any).offerId, ancillaryId: (anc as any).id });
        }
      }
    }

    if (targets.length === 0) return { status: "success", cleaned: false };

    showLoader();
    try {
      await Promise.all(
        targets.map((t) =>
          deleteAncillaryFromOffer(bookingId, t.offerId, t.ancillaryId, false).catch((e) => {
            console.warn("[CleanupOrphanAddonsAction] DELETE failed (non-fatal):", t.ancillaryId, e?.message);
            return { status: "error", message: e?.message };
          }),
        ),
      );

      const refreshed = await getBooking(bookingId, false);
      if (refreshed.status === "ok" && refreshed.answer) {
        updateRecoilState("bookingResponseAtom", refreshed.answer);
      }
      return { status: "success", cleaned: true };
    } catch (e: any) {
      console.warn("[CleanupOrphanAddonsAction] cleanup failed:", e?.message);
      return { status: "success", cleaned: true };
    } finally {
      hideLoader();
    }
  }
}

export const cleanupOrphanAddonsAction = new CleanupOrphanAddonsAction();
